import useApi, { ApiOptions } from '../base/useApi';
interface Params {
  userIds: string[];
  active: Boolean;
}

interface Result {}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/users/setActive',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSaveUserActive = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useSaveUserActiveLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveUserActive;
